/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// material
import { SortableList } from '@insticator/insticator-ui'; // iui-material
import Area from 'pages/dashboard/reports/detail/area/area';
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/reports/detail/dimensions/dimensions_styles';



/* ========== ~~~~~~~~~~ REPORT DIMENSIONS ~~~~~~~~~~ ========== */
const ReportDimensions = (props) => {

    const handleOrderChange = (order) => {
        let newArray = order.filter((currentValue) => (props.dimensions.includes(currentValue)));
        props.setReportProperties({ dimensions: newArray, order: order })
    }

    const handleChange = (order, value) => {
        let copiedArray = Array.from(props.dimensions);
        if (copiedArray.includes(value)) {
            let newArray = copiedArray.filter((currentValue) => value != currentValue);
            props.setReportProperties({ dimensions: newArray, order: order, selectedReportDataValid: Object.assign({}, props.valid, { dimensions: newArray.length > 0 }) });
        } else {
            let newArray = order.filter((currentValue) => (props.dimensions.includes(currentValue) || currentValue === value));
            props.setReportProperties({ dimensions: newArray, order: order, selectedReportDataValid: Object.assign({}, props.valid, { dimensions: newArray.length > 0 }) });
        }
    }

    return (
        <Area name={`dimensions`}
            klass={`${props.classes.dimensions}`}
            title={`Dimensions`}
            tooltip={<p>Dimensions will constitute individual columns on your report. Turn dimensions on and off, and reorganize them to customize your report.</p>}>
            <SortableList selected={props.dimensions} order={props.order}
                items={[{ value: 'DATE', text: 'Date' },
                { value: 'SITE', text: 'Site' },
                { value: 'DEVICE', text: 'Device' },
                { value: 'GEO', text: 'Country' },
                { value: 'AD_UNIT', text: 'Ad Unit' }]}
                handleChange={(order, value) => handleChange(order,value)}
                handleOrderChange={(order) => handleOrderChange(order)}
                error={{ message: 'A minimum of one dimension is required.', enabled: props.valid.dimensions === false }} />
        </Area>
    );
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(ReportDimensions);
